import type { Address } from '@/lib/services/addresses/addresses.types'

/** Any location payload: a `Location`, a `LocationListItem`, or a location an availability change names. */
interface NamedLocation {
  id: number
  address?: Pick<Address, 'name' | 'line1'> | null
}

/**
 * A location's name: its address's name, else its street line, else its id. Most single-location
 * shops never name their location, so the street is what florists recognize it by.
 */
export function getLocationName(location: NamedLocation): string {
  return (
    location.address?.name?.trim() || location.address?.line1?.trim() || `Location #${location.id}`
  )
}
